export default __webpack_public_path__ + "static/media/splash-image-2.71144f5d.png";